@import "../../themes/stories.globals";
@import "../grid/grid.mixins";

// Row
// --------------------------------------------------

:host {
  display: flex;

  flex-wrap: wrap;
}
